export const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:4000/api";

const TOKEN_KEY = "budgetsprint-token";

export const getToken = () => {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
};

export const setToken = (token) => {
  try {
    localStorage.setItem(TOKEN_KEY, token);
  } catch {
    // Storage unavailable - login just won't persist across reloads.
  }
};

export const clearToken = () => {
  try {
    localStorage.removeItem(TOKEN_KEY);
  } catch {
    // ignore
  }
};

// Same as fetch, but attaches the login token and signs the user out if the
// server says the token is no longer valid.
export const apiFetch = (url, options = {}) => {
  const token = getToken();
  const headers = { ...(options.headers || {}) };
  if (token) headers.Authorization = `Bearer ${token}`;

  return fetch(url, { ...options, headers }).then((res) => {
    if (res.status === 401 && token) {
      clearToken();
      window.dispatchEvent(new Event("auth:expired"));
    }
    return res;
  });
};
